export const defaultDotnetQueryOptions = {
  retry: false,
  refetchOnWindowFocus: false,
  networkMode: "always",
} as const;
